export default __webpack_public_path__ + "static/media/help-circle.5026fdda.svg";